"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
const Stack_1 = require("../Stack");
const Text_1 = require("../Text");
const BG_MAP = {
    trial: '#644ed7',
    pro: '#EDFFA5',
    neutral: '#2e2e2e',
    warning: 'rgba(255, 255, 255, 0.06)',
    highlight: '#ffffff',
    error: '#EF7A7A',
};
const COLOR_MAP = {
    trial: '#fff',
    pro: '#0E0E0E',
    neutral: 'inherit',
    warning: '#ef7a7a',
    highlight: 'inherit',
    error: '#0E0E0E',
};
const Badge = (_a) => {
    var { variant = 'neutral', icon, children, css, textSize = 12, iconSize = 12 } = _a, props = __rest(_a, ["variant", "icon", "children", "css", "textSize", "iconSize"]);
    return (react_1.default.createElement(Stack_1.Stack, Object.assign({ css: Object.assign({ alignItems: 'center', padding: '2px 8px', userSelect: 'none', borderRadius: '999px', backgroundColor: BG_MAP[variant], color: COLOR_MAP[variant] }, css), gap: 1 }, props),
        icon && react_1.default.createElement(Icon_1.Icon, { size: iconSize, name: icon }),
        children && (react_1.default.createElement(Text_1.Text, { size: textSize, lineHeight: "16px" }, children))));
};
exports.Badge = Badge;
